import React, {useState, useEffect, useRef } from 'react';
import BarGraph from './graph/BarGraph';  // BarGraphコンポーネント
import LineGraph from './graph/LineGraph';  // LineGraphコンポーネント
import ScatterGraph from './graph/ScatterGraph';  // ScatterGraphコンポーネント
import '../css/ChatGraph.css';
import ManualBarGraphWrapper from './graph/ManualBarGraphWrapper';
import ManualScatterGraph from './graph/ManualScatterGraph';
import ManualLineGraphWrapper from './graph/ManualLineGraphWrapper'

const ChatGraph = ({ graphs, height=500 }) => {
  const containerRef = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setWidth(containerRef.current.clientWidth);
      }
    };

    updateWidth(); // 初回取得
    window.addEventListener('resize', updateWidth); // リサイズ時に更新
    return () => window.removeEventListener('resize', updateWidth); // クリーンアップ
  }, [graphs]);

  return (
    <div className='chat-fig' ref={containerRef}>
      {graphs.map((graphObj, graphIndex) => {
        let graph = graphObj.fig;
        let data;
        if (graph.data_found) { // マニュアルで作成したグラフ
          if (graph.graph_type === 'bar' || graph.graph_type === 'line') {
              data = graph.graphs.map((graphData, index) => ({
                x: graphData.x, 
                y: graphData.y,
                labels: null,
                name: graphData.name,
                x_unit: graphData.x_unit,
                y_unit: graphData.y_unit
            }))
          } else if (graph.graph_type === 'scatter') {
              data = graph.graphs.map((graphData, index) => ({
                series: graphData.series,
                x_name: graphData.x_name,
                y_name: graphData.y_name,
                x_unit: graphData.x_unit,
                y_unit: graphData.y_unit
              }))
          }
          ;
        } else {
            if (['bar', 'line'].includes(graph.settings.graph_type)) {
                data = graph.x[0].map((xValue, index) => ({
                  x: xValue, 
                  y: graph.y.map((ySeries) => ySeries[index]),
                  labels: graph?.text.map((textSeries) => textSeries[index]),
              }));
            } else if (graph.settings.graph_type === 'scatter') {
              data = []
              for (let i = 0; i < graph.x.length; i ++) {
                  const series = [];
                  for (let j = 0;j < graph.x[i].length; j ++) {
                      series.push(
                        {
                          x: graph.x[i][j],
                          y: graph.y[i][j],
                          xName: graph.x_name,
                          yName: graph.y_name,
                          xUnit: graph.x_unit,
                          yUnit: graph.y_unit,
                          dataName: graph.data_name[i][j],
                          seriesName: graph.names[i],
                          seriesIndex: i,
                        }
                      )
                  }
                  data.push(series)
              }
            }
        }

        return (
          <div key={graphIndex} className='graph-container'>
            <h2 className='chat-fig-title'>{graph.title}</h2>

            {graph && graph.data_found && graph.graph_type === 'bar' ? (
              <ManualBarGraphWrapper data={data} height={height} width={width} />
            ) : graph && graph.settings && graph.settings.graph_type === 'bar' ? (
              <BarGraph data={data} graph={graph} height={height} width={width} />
            ) : null}

            {graph && graph.data_found && graph.graph_type === 'line' ? (
              <ManualLineGraphWrapper data={data} height={height} width={width} />
            ) : graph && graph.settings && graph.settings.graph_type === 'line' ? (
              <LineGraph data={data} graph={graph} height={height} width={width} />
            ) : null}

            {graph && graph.data_found && graph.graph_type === 'scatter' ? (
              <ManualScatterGraph data={data[0]} height={height} />
            ) : graph && graph.settings && graph.settings.graph_type === 'scatter' ? (
              <ScatterGraph data={data} graph={graph} height={height} />
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

export default ChatGraph;
